module.exports = __webpack_public_path__ + "img/水瓶座.303676be.svg";